import { useEffect, useState } from 'react'
import { message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { UPLOAD_FILES_NO_SAVE } from '../../../api/orderManage'
import {
  APTITUDE_ACCEPT_EXT,
  APTITUDE_MAX_SIZE,
  isDuplicateFileName,
} from './helpers'
import { AptitudeFile, UploadModalProps } from './typing'

// 后端上传返回项（/uploadFile/upload）
interface UploadRespItem {
  url: string
  baseUrl: string
  name: string
}

const ACCEPT_REG = new RegExp(
  `^.*(${APTITUDE_ACCEPT_EXT.split(',').join('|')})$`,
  'i',
)

// 上传弹框逻辑：资质类型选择 + 暂存文件增删 + 上传校验
export default function useUploadModal(props: UploadModalProps) {
  const { open, productCode, existedList, onOk } = props
  const [attachType, setAttachType] = useState<string | undefined>(undefined)
  const [stagedFiles, setStagedFiles] = useState<AptitudeFile[]>([])
  const [uploading, setUploading] = useState(false)

  // 每次打开重置暂存与选择
  useEffect(() => {
    if (open) {
      setAttachType(undefined)
      setStagedFiles([])
      setUploading(false)
    }
  }, [open])

  // 实际上传
  async function uploadfile(file: RcFile) {
    setUploading(true)
    try {
      const res = await UPLOAD_FILES_NO_SAVE(
        { type: 'materialAptitude', code: productCode },
        [file],
      )
      if (res.code === 0 && Array.isArray(res.data) && res.data.length) {
        const item = res.data[0] as UploadRespItem
        const newFile: AptitudeFile = {
          docType: attachType as string,
          name: item.name,
          url: item.url,
          baseUrl: item.baseUrl,
        }
        setStagedFiles((prev) => [...prev, newFile])
      }
    } finally {
      setUploading(false)
    }
  }

  // 上传前校验：先选类型 → 大小 → 格式 → 同类型重名
  function beforeUpload(file: RcFile) {
    if (!attachType) {
      message.warning('请先选择图片资质类型')
      return false
    }
    if (file.size > APTITUDE_MAX_SIZE) {
      message.error('请勿上传超过10MB的文件！')
      return false
    }
    if (file.name.search(ACCEPT_REG) === -1) {
      message.error('请上传正确的文件格式！')
      return false
    }
    if (isDuplicateFileName(file.name, attachType, existedList, stagedFiles)) {
      message.error('同一资质类型下已存在同名文件，请勿重复上传')
      return false
    }
    uploadfile(file)
    return false
  }

  // 删除暂存文件
  function onRemoveStaged(target: AptitudeFile) {
    setStagedFiles((prev) => prev.filter((item) => item !== target))
  }

  // 确定：回传暂存文件
  function onConfirm() {
    if (!stagedFiles.length) {
      message.warning('请先上传资质文件')
      return
    }
    onOk(stagedFiles)
  }

  return {
    attachType,
    setAttachType,
    stagedFiles,
    uploading,
    beforeUpload,
    onRemoveStaged,
    onConfirm,
  }
}
import { useEffect, useState } from 'react'
import { message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { UPLOAD_FILES_NO_SAVE } from '../../../api/orderManage'
import {
  APTITUDE_ACCEPT_EXT,
  APTITUDE_MAX_SIZE,
  isDuplicateFileName,
} from './helpers'
import { AptitudeFile, UploadModalProps } from './typing'

// 后端上传返回项（/uploadFile/upload）
interface UploadRespItem {
  url: string
  baseUrl: string
  name: string
}

const ACCEPT_REG = new RegExp(
  `^.*(${APTITUDE_ACCEPT_EXT.split(',').join('|')})$`,
  'i',
)

// 上传弹框逻辑：资质类型选择 + 暂存文件增删 + 上传校验
export default function useUploadModal(props: UploadModalProps) {
  const { open, productCode, existedList, onOk } = props
  const [attachType, setAttachType] = useState<string | undefined>(undefined)
  const [stagedFiles, setStagedFiles] = useState<AptitudeFile[]>([])
  const [uploading, setUploading] = useState(false)

  // 每次打开重置暂存与选择
  useEffect(() => {
    if (open) {
      setAttachType(undefined)
      setStagedFiles([])
      setUploading(false)
    }
  }, [open])

  // 实际上传
  async function uploadfile(file: RcFile) {
    setUploading(true)
    try {
      const res = await UPLOAD_FILES_NO_SAVE(
        { type: 'materialAptitude', code: productCode },
        [file],
      )
      if (res.code === 0 && Array.isArray(res.data) && res.data.length) {
        const item = res.data[0] as UploadRespItem
        const newFile: AptitudeFile = {
          docType: attachType as string,
          name: item.name,
          url: item.url,
          baseUrl: item.baseUrl,
        }
        setStagedFiles((prev) => [...prev, newFile])
      }
    } finally {
      setUploading(false)
    }
  }

  // 上传前校验：先选类型 → 大小 → 格式 → 同类型重名
  function beforeUpload(file: RcFile) {
    if (!attachType) {
      message.warning('请先选择图片资质类型')
      return false
    }
    if (file.size > APTITUDE_MAX_SIZE) {
      message.error('请勿上传超过10MB的文件！')
      return false
    }
    if (file.name.search(ACCEPT_REG) === -1) {
      message.error('请上传正确的文件格式！')
      return false
    }
    if (isDuplicateFileName(file.name, attachType, existedList, stagedFiles)) {
      message.error('同一资质类型下已存在同名文件，请勿重复上传')
      return false
    }
    uploadfile(file)
    return false
  }

  // 删除暂存文件
  function onRemoveStaged(target: AptitudeFile) {
    setStagedFiles((prev) => prev.filter((item) => item !== target))
  }

  // 确定：回传暂存文件
  function onConfirm() {
    if (!stagedFiles.length) {
      message.warning('请先上传资质文件')
      return
    }
    onOk(stagedFiles)
  }

  return {
    attachType,
    setAttachType,
    stagedFiles,
    uploading,
    beforeUpload,
    onRemoveStaged,
    onConfirm,
  }
}
